import router from '@/router';
import { AuthService, Container, Navigation, 提示ServiceInjectToken } from 'zr-arch';
import { container } from 'tsyringe';
import config from '@/config';
import { LoginCallBack, SilentCallBack } from '@/views';
import { 提示Service } from '@/infrastructure/service/提示Service';

export default class Startup {
    static configurationApp(): void {
        this.configurationRouter();
    }

    private static configurationRouter(): void {
        const navigation = new Navigation(router as any);
        const navigationProvider = { useValue: navigation };
        container.register(Navigation, navigationProvider);
        Container.register(Navigation, navigationProvider);

        const authServiceProvider = {
            useValue: new AuthService(
                config.Authority,
                'expert_coll_web',
                'openid role',
                `${window.location.origin}/${navigation.getUrl(SilentCallBack)}`,
                `${window.location.origin}${navigation.getUrl(LoginCallBack)}`
            ),
        };
        container.register(AuthService, authServiceProvider);
        Container.register(AuthService, authServiceProvider);

        Container.register(提示ServiceInjectToken, {
            useValue: container.resolve(提示Service),
        });
    }
}
